<template>
  <div>
    <header class="maui-bar aui-bar aui-bar-nav">
      <router-link class="aui-pull-left aui-btn" to="/supply">
        <span class="aui-iconfont aui-icon-left"></span>
      </router-link>
      <div class="aui-title">全国</div>
      <a class="aui-pull-right aui-btn" href="javascript:void(0);"></a>
    </header>

    <!-- collapse -->
    <van-loading color="#1989fa" v-if="onloadinga" />
    <van-collapse v-model="activeNames" v-for="item in countrylist" :key="item.key">
      <van-collapse-item :name="item.id">
        <div slot="title">{{item.name}}</div>
        <div class="battery-country-li">
          <div v-for="n in item.infoDTOList" :key="n.key">
            <div @click="oncountry(n.val,n.name)">{{n.name}}</div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!-- collapse end -->
  </div>
</template>

<script>
export default {
  name: "country",
  data() {
    return {
      activeNames: ["1"],
      countrylist: "",
      comments: [],
      showPage: 1,
      pageSize: 10,
      pageindex: 1,
      loading: false,
      finished: false,
      totalElements: "",
      onloadinga: true
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    oncountry(val, name) {
      console.log("这是a兄弟原使val" + val, name);
      this.$emit("isFucountry", val, name);
    },
    onLoad() {
      this.$axios
        .get("/micro/permission_goods/area/read/queryList")
        .then(res => {
          this.onloadinga = false;
          this.countrylist = res.data.data;
          console.log(this.countrylist);
        }); // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore(); // 加载状态结束
        this.loading = false;
        if (this.comments.length >= this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },

    getMore() {
      this.pageindex++;
    },
    getNews(item, i) {
      this.$router.push({ path: "/supplyform", query: { xqid: item } });
    }
  }
};
</script>

<style>
.battery-country-li > div {
  width: 30%;
  background: #f2f2f2;
  border-radius: 5px;
  display: inline-block;
  text-align: center;
  padding: 15px 0;
  margin: 5px 4px;
}
.van-cell__title {
  text-align: left;
}
.van-collapse-item__content {
  text-align: left;
}
.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/view/areacountry.vue